import { IconType } from '../../../types/icon.type';
import Icon from '../../icons/icon';
import { HStack } from '../../layouts/stack.layout';
import Text from '../../typography/v2/text';

type DropdownButtonProps = {
  text: string;
  icon: IconType;
};

export const DROPDOWN_MENU = {
  item: 'px-8 py-1 hover:bg-[#1c1c1c] hover:outline-none rounded cursor-pointer',
  action: 'hover:outline-none',
};

export default function DropdownButton(props: DropdownButtonProps) {
  const { text, icon } = props;
  return (
    <HStack gap="base" extensions="py-3 items-center">
      <Icon size="sm" icon={icon} />
      <Text variant="overlay-text">{text}</Text>
    </HStack>
  );
}
